import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import '../../styles/midnight-lab.css';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    
    if (!email || !password) {
      setError('Please enter both email and password');
      return;
    }

    // Mock login - accept any credentials for now
    const success = signIn(email, password);
    if (success) {
      navigate('/dashboard');
    } else {
      setError('Invalid credentials');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'var(--color-bg-primary)',
      padding: 'var(--space-4)'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        padding: 'var(--space-8)',
        borderBottom: '1px solid rgba(0, 16, 17, 0.1)'
      }}>
        <h1 style={{
          fontFamily: 'var(--font-sans)',
          fontSize: 'clamp(2rem, 4vw, 3rem)',
          fontWeight: 700,
          color: 'var(--color-text-primary)',
          marginBottom: 'var(--space-2)',
          textAlign: 'center'
        }}>
          Dashboard Login
        </h1>
        <p style={{
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-base)',
          color: 'var(--color-text-secondary)',
          textAlign: 'center',
          marginBottom: 'var(--space-8)'
        }}>
          Sign in to access the team dashboard
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 'var(--space-6)' }}>
            <label style={{
              display: 'block',
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-sm)',
              fontWeight: 600,
              color: 'var(--color-text-primary)',
              marginBottom: 'var(--space-2)'
            }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: '100%',
                padding: 'var(--space-3)',
                fontFamily: 'var(--font-sans)',
                fontSize: 'var(--text-base)',
                border: '1px solid rgba(0, 16, 17, 0.1)',
                backgroundColor: 'var(--color-bg-primary)',
                color: 'var(--color-text-primary)',
                transition: 'border-color var(--transition-base)'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = 'var(--color-frozen-lake)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(0, 16, 17, 0.1)';
              }}
            />
          </div>

          <div style={{ marginBottom: 'var(--space-6)' }}>
            <label style={{
              display: 'block',
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-sm)',
              fontWeight: 600,
              color: 'var(--color-text-primary)',
              marginBottom: 'var(--space-2)'
            }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: 'var(--space-3)',
                fontFamily: 'var(--font-sans)',
                fontSize: 'var(--text-base)',
                border: '1px solid rgba(0, 16, 17, 0.1)',
                backgroundColor: 'var(--color-bg-primary)',
                color: 'var(--color-text-primary)',
                transition: 'border-color var(--transition-base)'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = 'var(--color-frozen-lake)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(0, 16, 17, 0.1)';
              }}
            />
          </div>

          {error && (
            <div style={{
              padding: 'var(--space-3)',
              marginBottom: 'var(--space-4)',
              backgroundColor: 'rgba(152, 206, 0, 0.1)',
              color: 'var(--color-text-primary)',
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-sm)',
              borderRadius: '4px'
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            style={{
              width: '100%',
              padding: 'var(--space-4)',
              backgroundColor: 'var(--color-text-primary)',
              color: 'var(--color-text-light)',
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-base)',
              fontWeight: 600,
              border: 'none',
              cursor: 'pointer',
              transition: 'all var(--transition-base)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'var(--color-frozen-lake)';
              e.target.style.color = 'var(--color-text-primary)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'var(--color-text-primary)';
              e.target.style.color = 'var(--color-text-light)';
            }}
          >
            Sign In
          </button>
        </form>

        <p style={{
          marginTop: 'var(--space-6)',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-xs)',
          color: 'var(--color-text-secondary)',
          textAlign: 'center'
        }}>
          Demo: Use any email and password to sign in
        </p>
      </div>
    </div>
  );
}

export default LoginPage;

